<div class="dashboard">
  <pg-header
    title="OWMS Dashboard"
    [bckbtn]="false"
    ticon="database"
  ></pg-header>
  <div style="text-align: right">
    <nz-date-picker
      nzFormat="dd-MM-yyyy"
      [nzDisabledDate]="disabledDate"
      [(ngModel)]="datePk"
      (ngModelChange)="onDtChange($event)"
      style="width: 200px"
    ></nz-date-picker>
  </div>
  @if (showLdr) {
  <ds-loading></ds-loading>
  }
  <div class="row">
    <div class="col-md-6">
      <nz-card>
        <div class="gates-card-bg-color border-radius-3">
          <p
            class="text-center font-size-18 font-weight-600 text-white mt-0 mb-0"
          >
            Gates Scanned
          </p>
          <p
            class="text-center font-size-30 font-weight-600 text-white mt-0 mb-0"
          >
            {{ cvrdCrdData.scnd_gts }}/{{ cvrdCrdData.tot_gts }}
          </p>
          <p
            class="text-center font-size-12 font-weight-600 text-white mt-0 mb-0"
          >
            Scanned Gates vs Total Gates
          </p>
          <div>
            <div class="m--space-10"></div>
            <div class="progress">
              <div
                class="progress-bar m-progress--sm prgsBrGte"
                role="progressbar"
                [ngStyle]="getWdth(cvrdCrdData.tot_scnd_prcnt)"
                aria-valuenow="75"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                {{ cvrdCrdData.tot_scnd_prcnt }}%
              </div>
            </div>
            <div>
              <p class="pdngRgt_4 ulbdshbrdOptns txtClrWhte ng-binding">
                {{ cvrdCrdData.tot_scnd_prcnt }}%
              </p>
            </div>
          </div>
        </div>
        <div
          nz-row
          [nzGutter]="8"
          style="
            box-shadow: 0 4px 8px 0 rgb(0 0 0 / 0%),
              0 6px 20px 0 rgb(0 0 0 / 10%);
          "
        >
          <div nz-col [nzSpan]="12" class="attnBdrRght">
            <p
              class="text-center font-size-14 font-weight-400 fuse-black-40-fg mt-2 mb-0"
            >
              Residential
            </p>
            <p
              class="text-center font-size-24 font-weight-400 fuse-black-30-fg mt-0 mb-0"
            >
              {{ cvrdCrdData?.hh_scnd }} /{{ cvrdCrdData?.hh_tot }}
            </p>

            <p
              class="text-center font-size-10 font-weight-400 fuse-black-50-fg mt-0 mb-8"
            >
              Scanned vs Total Gates
            </p>
          </div>
          <div nz-col [nzSpan]="12">
            <p
              class="text-center font-size-14 font-weight-400 fuse-black-40-fg mt-2 mb-0"
            >
              Residential&Commercial
            </p>
            <p
              class="text-center font-size-24 font-weight-400 fuse-black-30-fg mt-0 mb-0"
            >
              {{ cvrdCrdData?.rc_scnd }} /{{ cvrdCrdData?.rc_tot }}
            </p>
            <p
              class="text-center font-size-10 font-weight-400 fuse-black-50-fg mt-0 mb-8"
            >
              Scanned vs Total Gates
            </p>
          </div>
          <div nz-col [nzSpan]="12" class="gtsBdrRght brdertop">
            <p
              class="text-center font-size-14 font-weight-400 fuse-black-40-fg mt-2 mb-0"
            >
              Apartments
            </p>
            <p
              class="text-center font-size-24 font-weight-400 fuse-black-30-fg mt-0 mb-0"
            >
              {{ cvrdCrdData?.a_scnd }} /{{ cvrdCrdData?.a_tot }}
            </p>
            <p
              class="text-center font-size-10 font-weight-400 fuse-black-50-fg mt-0 mb-8"
            >
              Scanned vs Total Gates
            </p>
          </div>
          <div nz-col [nzSpan]="12" class="brdertop">
            <p
              class="text-center font-size-14 font-weight-400 fuse-black-40-fg mt-2 mb-0"
            >
              Bulk Commercial
            </p>
            <p
              class="text-center font-size-24 font-weight-400 fuse-black-30-fg mt-0 mb-0"
            >
              {{ cvrdCrdData?.bc_scnd }} /{{ cvrdCrdData?.bc_tot }}
            </p>
            <p
              class="text-center font-size-10 font-weight-400 fuse-black-50-fg mt-0 mb-8"
            >
              Scanned vs Total Gates
            </p>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 mgnb-2 p-8" style="margin-top: 3%">
          <p class="crd-gp-hrd" style="color: #41abb3">
            Gates Scanned Last 7 Days
          </p>
          <div style="display: block" style="margin-top: 1.5%">
            <!-- <canvas baseChart class="hmechrt"
            [datasets]="barChartData"
            [labels]="barChartLabels"
            [options]="barChartOptions"
            [colors]="barChartColors"
            [plugins]="barChartPlugins"
            [legend]="barChartLegend"
            [chartType]="barChartType">
          </canvas> -->
          </div>
        </div>
      </nz-card>
    </div>
    <div class="col-md-6">
      <nz-card>
        <div class="attendance-card-bg-color border-radius-3">
          <p
            class="text-center font-size-18 font-weight-600 text-white mt-0 mb-0"
          >
            Attendance
          </p>
          <p
            class="text-center font-size-30 font-weight-600 text-white mt-0 mb-0"
          >
            {{ attndncCrdData?.prsnt_emp }}/{{ attndncCrdData?.tot_emp }}
          </p>
          <p
            class="text-center font-size-12 font-weight-600 text-white mt-0 mb-0"
          >
            Total Present vs Total Members
          </p>
          <div>
            <!-- <mat-progress-bar mode="determinate" value="4"></mat-progress-bar> -->
            <div class="m--space-10"></div>
            <div class="progress">
              <div
                class="progress-bar m-progress--sm prgsBrGte"
                role="progressbar"
                [ngStyle]="getAWdth(attdPer)"
                aria-valuenow="75"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                {{ attdPer }}%
              </div>
            </div>
            <div>
              <p class="pdngRgt_4 ulbdshbrdOptns txtClrWhte ng-binding">
                {{ attdPer }}%
              </p>
            </div>
          </div>
        </div>
        <div
          nz-row
          [nzGutter]="8"
          style="
            box-shadow: 0 4px 8px 0 rgb(0 0 0 / 0%),
              0 6px 20px 0 rgb(0 0 0 / 10%);
          "
        >
          <div nz-col [nzSpan]="12" class="attnBdrRght">
            <p
              class="text-center font-size-14 font-weight-400 fuse-black-40-fg mt-2 mb-0"
            >
              PH Workers
            </p>
            <p
              class="text-center font-size-24 font-weight-400 fuse-black-30-fg mt-0 mb-0"
            >
              {{ attndncCrdData?.ph_prsnt }}/{{ attndncCrdData?.ph_tot }}
            </p>
            <!-- <p class="text-center font-size-24 font-weight-400 fuse-black-30-fg mt-0 mb-0">
        {{attndnceCrdRcvdData[0]?.ph_prsnt}}/{{attndnceCrdRcvdData[0]?.ph_tot}}</p> -->
            <p
              class="text-center font-size-10 font-weight-400 fuse-black-50-fg mt-0 mb-8"
            >
              Present vs Work Days
            </p>
          </div>
          <div nz-col [nzSpan]="12">
            <p
              class="text-center font-size-14 font-weight-400 fuse-black-40-fg mt-2 mb-0"
            >
              Drivers
            </p>
            <p
              class="text-center font-size-24 font-weight-400 fuse-black-30-fg mt-0 mb-0"
            >
              {{ attndncCrdData?.dr_prsnt }}/{{ attndncCrdData?.dr_tot }}
            </p>
            <!-- <p class="text-center font-size-24 font-weight-400 fuse-black-30-fg mt-0 mb-0">
      {{attndnceCrdRcvdData[0]?.dr_prsnt}}/{{attndnceCrdRcvdData[0]?.dr_tot}}</p> -->
            <p
              class="text-center font-size-10 font-weight-400 fuse-black-50-fg mt-0 mb-8"
            >
              Present vs Work Days
            </p>
          </div>
          <div nz-col [nzSpan]="12" class="attnBdrRght brdertop">
            <p
              class="text-center font-size-14 font-weight-400 fuse-black-40-fg mt-2 mb-0"
            >
              Loaders
            </p>
            <p
              class="text-center font-size-24 font-weight-400 fuse-black-30-fg mt-0 mb-0"
            >
              {{ attndncCrdData?.ld_prsnt }}/{{ attndncCrdData?.ld_tot }}
            </p>
            <!-- <p class="text-center font-size-24 font-weight-400 fuse-black-30-fg mt-0 mb-0">
    {{attndnceCrdRcvdData[0]?.ld_prsnt}}/{{attndnceCrdRcvdData[0]?.ld_tot}}</p> -->
            <p
              class="text-center font-size-10 font-weight-400 fuse-black-50-fg mt-0 mb-8"
            >
              Present vs Work Days
            </p>
          </div>
          <div nz-col [nzSpan]="12" class="brdertop">
            <p
              class="text-center font-size-14 font-weight-400 fuse-black-40-fg mt-2 mb-0"
            >
              Supervisors
            </p>
            <p
              class="text-center font-size-24 font-weight-400 fuse-black-30-fg mt-0 mb-0"
            >
              {{ attndncCrdData?.sp_prsnt }}/{{ attndncCrdData?.sp_tot }}
            </p>
            <!-- <p class="text-center font-size-24 font-weight-400 fuse-black-30-fg mt-0 mb-0">
  {{attndnceCrdRcvdData[0]?.sp_prsnt}}/{{attndnceCrdRcvdData[0]?.sp_tot}}</p> -->
            <p
              class="text-center font-size-10 font-weight-400 fuse-black-50-fg mt-0 mb-8"
            >
              Present vs Work Days
            </p>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 mgnb-2 p-8" style="margin-top: 3%">
          <p class="crd-gp-hrd" style="color: #5f56bf">
            Attendance Last 7 Days
          </p>
          <div style="display: block" style="margin-top: 1.5%">
            <!-- <canvas baseChart class="hmechrt"
    [labels]="lineChartLabels"
    [colors]="lineChartColors"
    [options]="lineChartOptions"
    [legend]="lineChartLegend"
    [chartType]="lineChartType"
    [plugins]="lineChartPlugins"
    [datasets]="lineChartData">
  </canvas> -->
          </div>
        </div>
      </nz-card>
    </div>
  </div>

  <div class="row">
    <nz-card style="margin: 1%; width: 100%">
      <nz-tabs>
        <nz-tab nzTitle="Sachivalayam Data">
          @if (usrAcsErrMsg == false) {
          <div class="col-md-12"></div>
          } @if (usrAcsErrMsg == false) {
          <div class="row gridTop" id="target">
            <div class="col-lg-12 col-md-12 mgnb-2 p-8">
              <app-data-grid
                [toolbarItems]="pdfToolbar"
                id="gridContainer"
                class="p-8"
                style="width: 100%"
                [dataSource]="svmTbleData"
                [searchPanel]="true"
                [filterRow]="true"
                [filterPanel]="true"
                [groupPanel]="true"
                [columnChooser]="true"
                [allowExport]="true"
                exportFileName="Sachivalayam Data"
                [pageSize]="10"
                [allowedPageSizes]="[10, 25, 50, 100]"
                [showPageSizeSelector]="true"
                [rowAlternationEnabled]="true"
                [showBorders]="true"
                (cellClick)="onCellClick1($event)"
                [cellPrepared]="bound_onCellPrepared1"
              >
                <app-grid-column
                  dataField="sno"
                  caption="Sno"
                  alignment="center"
                  width="50"
                  allowResizing="true"
                ></app-grid-column>
                <app-grid-column
                  dataField="Date"
                  caption="Date"
                  alignment="center"
                  width="100"
                  allowResizing="true"
                ></app-grid-column>
                <app-grid-column
                  dataField="svm_nm"
                  caption="Sachivalayam Name"
                  alignment="left"
                  width="170"
                  allowResizing="true"
                ></app-grid-column>
                <app-grid-column caption="Scanned Gates" alignment="center">
                  <app-grid-column
                    dataField="Total_Gates"
                    caption="Total"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                  <app-grid-column
                    dataField="Scanned_Gates"
                    caption="Scanned"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                  <app-grid-column
                    dataField="Scanned_Percentage"
                    caption="Scanned %"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                </app-grid-column>
                <app-grid-column caption="Residential" alignment="center">
                  <app-grid-column
                    dataField="hh_tot_gtes"
                    caption="Total"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                  <app-grid-column
                    dataField="hh_scnd_gtes"
                    caption="Scanned"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                  <app-grid-column
                    dataField="hh_scnd_prcnt"
                    caption="Scanned %"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                </app-grid-column>
                <app-grid-column
                  caption="Commercial & Residential"
                  alignment="center"
                >
                  <app-grid-column
                    dataField="rc_tot_gtes"
                    caption="Total"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                  <app-grid-column
                    dataField="rc_scnd_gtes"
                    caption="Scanned"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                  <app-grid-column
                    dataField="rc_scnd_prcnt"
                    caption="Scanned %"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                </app-grid-column>
                <app-grid-column caption="Apartment" alignment="center">
                  <app-grid-column
                    dataField="a_tot_gtes"
                    caption="Total"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                  <app-grid-column
                    dataField="a_scnd_gtes"
                    caption="Scanned"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                  <app-grid-column
                    dataField="a_scnd_prcnt"
                    caption="Scanned %"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                </app-grid-column>
                <app-grid-column caption="Bulk Commercial" alignment="center">
                  <app-grid-column
                    dataField="bc_tot_gtes"
                    caption="Total"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                  <app-grid-column
                    dataField="bc_scnd_gtes"
                    caption="Scanned"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                  <app-grid-column
                    dataField="bc_scnd_prcnt"
                    caption="Scanned %"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                </app-grid-column>
              </app-data-grid>
            </div>
          </div>
          }
        </nz-tab>
        <nz-tab nzTitle="Micropocket Data">
          @if (usrAcsErrMsg == false) {
          <div class="col-md-12"></div>
          } @if (usrAcsErrMsg == false) {
          <div class="row gridTop" id="target1">
            <div class="col-lg-12 col-md-12 mgnb-2 p-8">
              <!-- [dataSource]="tcktsLst" -->
              <app-data-grid
                [toolbarItems]="pdfToolbar1"
                id="gridContainer1"
                class="p-8"
                style="width: 100%"
                [dataSource]="mcrpctTbleData"
                [searchPanel]="true"
                [filterRow]="true"
                [filterPanel]="true"
                [groupPanel]="true"
                [columnChooser]="true"
                [allowExport]="true"
                exportFileName="Micropocket Data"
                [pageSize]="10"
                [allowedPageSizes]="[10, 25, 50, 100]"
                [showPageSizeSelector]="true"
                [rowAlternationEnabled]="true"
                [showBorders]="true"
                (cellClick)="onCellClick($event)"
                [cellPrepared]="bound_onCellPrepared"
              >
                <app-grid-column
                  dataField="sno"
                  caption="Sno"
                  alignment="center"
                  width="50"
                  allowResizing="true"
                ></app-grid-column>
                <app-grid-column
                  dataField="date"
                  caption="Date"
                  alignment="center"
                  width="100"
                  allowResizing="true"
                ></app-grid-column>
                <app-grid-column
                  dataField="mcrpt_nm"
                  caption="Micropocket Name"
                  alignment="left"
                  width="170"
                  allowResizing="true"
                ></app-grid-column>
                <app-grid-column caption="Scanned Gates" alignment="center">
                  <app-grid-column
                    dataField="tot_gtes"
                    caption="Total"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                  <app-grid-column
                    dataField="scnd_gts"
                    caption="Scanned"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                  <app-grid-column
                    dataField="tot_scnd_prcnt"
                    caption="Scanned %"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                </app-grid-column>
                <app-grid-column caption="Residential" alignment="center">
                  <app-grid-column
                    dataField="hh_tot_gtes"
                    caption="Total"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                  <app-grid-column
                    dataField="hh_scnd_gtes"
                    caption="Scanned"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                  <app-grid-column
                    dataField="hh_scnd_prcnt"
                    caption="Scanned %"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                </app-grid-column>
                <app-grid-column
                  caption="Commercial & Residential"
                  alignment="center"
                >
                  <app-grid-column
                    dataField="rc_tot_gtes"
                    caption="Total"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                  <app-grid-column
                    dataField="rc_scnd_gtes"
                    caption="Scanned"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                  <app-grid-column
                    dataField="rc_scnd_prcnt"
                    caption="Scanned %"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                </app-grid-column>
                <app-grid-column caption="Apartment" alignment="center">
                  <app-grid-column
                    dataField="a_tot_gtes"
                    caption="Total"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                  <app-grid-column
                    dataField="a_scnd_gtes"
                    caption="Scanned"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                  <app-grid-column
                    dataField="a_scnd_prcnt"
                    caption="Scanned %"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                </app-grid-column>
                <app-grid-column caption="Bulk Commercial" alignment="center">
                  <app-grid-column
                    dataField="bc_tot_gtes"
                    caption="Total"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                  <app-grid-column
                    dataField="bc_scnd_gtes"
                    caption="Scanned"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                  <app-grid-column
                    dataField="bc_scnd_prcnt"
                    caption="Scanned %"
                    alignment="center"
                    width="100"
                    allowResizing="true"
                  ></app-grid-column>
                </app-grid-column>
              </app-data-grid>
            </div>
          </div>
          }
        </nz-tab>
      </nz-tabs>
    </nz-card>
  </div>
</div>
